import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onInsightHoverChange", "recommendations", "isLoading", "isLeadingCardLoading", "hasMore", "fetchNextPage", "isFetchingNextPage", "getItButtonOverride", "onItemClick", "onAiInsightsClick", "showHeroCard", "titleOverflowStrategy", "rowTitleOverflowStrategy", "clickableRows", "clickableLeadingCard", "promotedLabels", "useCompactRecommendationsLayout", "isLeanView", "hideAlternativesHeading", "alternativesHeadingGap", "showTrustBuilders", "hideFreeWithSitePlanBadge", "hideExactMatchHeadline", "pricingOptimized", "isBusinessEmail", "isPricingLoading", "suppressHarmonyCardStyling", "desktopContentPadding", "bareListOnly", "desktopContentGap", "insightsPaddingTop", "compactPriceLabel", "stackedMobileCards", "Layouts"],
  _excluded2 = ["children", "className"],
  _excluded3 = ["children", "priority"],
  _excluded4 = ["children", "className"],
  _excluded5 = ["children", "priority", "className"],
  _excluded6 = ["className"],
  _excluded7 = ["className"],
  _excluded8 = ["children", "className"];
import { RecommendationLabel } from '@wix/ambassador-premium-domains-v1-recommendation/types';
import { Box, Button, Divider, Heading, Loader, TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule, SearchRecommendationLayout } from '@wix/domains-search-suite';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { ChevronDown } from '@wix/wix-ui-icons-common/lazy';
import React, { useState } from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useIsHarmonyTheme } from '@wix/core-domain-search';
import { useMatchingLabels } from '../../hooks/useMatchingLabels';
import { useResultsPageConfig } from '../../hooks/useResultsPageConfig';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ExactMatchHeadline } from '../ExactMatchHeadline';
import { HeroCard, HeroCardSkeleton } from '../HeroCard';
import { HeroBusinessEmailExample } from '../HeroCard/HeroBusinessEmailExample';
import { LazyRecommendationLabel } from '../LazyRecommedationLabel/LazyRecommendationLabel';
import { AnimatedBanner } from '../AnimatedBanner';
import { GoogleWorkspaceBanner } from '../GoogleWorkspaceBanner';
import { createLeanLabelContainer, createOptimizedLabelContainer } from './suggestionLabelContainers';
import { RecommendationsDataHooks } from './dataHooks';
import s from './Recommendations.css';
export const Recommendations = _ref => {
  var _recommendations$, _recommendations$2, _mainCardItems$;
  let onInsightHoverChange = _ref.onInsightHoverChange,
    recommendations = _ref.recommendations,
    isLoading = _ref.isLoading,
    isLeadingCardLoading = _ref.isLeadingCardLoading,
    hasMore = _ref.hasMore,
    fetchNextPage = _ref.fetchNextPage,
    isFetchingNextPage = _ref.isFetchingNextPage,
    getItButtonOverride = _ref.getItButtonOverride,
    onItemClick = _ref.onItemClick,
    onAiInsightsClick = _ref.onAiInsightsClick,
    _ref$showHeroCard = _ref.showHeroCard,
    showHeroCard = _ref$showHeroCard === void 0 ? false : _ref$showHeroCard,
    _ref$titleOverflowStr = _ref.titleOverflowStrategy,
    titleOverflowStrategy = _ref$titleOverflowStr === void 0 ? 'ellipsis' : _ref$titleOverflowStr,
    _ref$rowTitleOverflow = _ref.rowTitleOverflowStrategy,
    rowTitleOverflowStrategy = _ref$rowTitleOverflow === void 0 ? titleOverflowStrategy : _ref$rowTitleOverflow,
    _ref$clickableRows = _ref.clickableRows,
    clickableRows = _ref$clickableRows === void 0 ? false : _ref$clickableRows,
    _ref$clickableLeading = _ref.clickableLeadingCard,
    clickableLeadingCard = _ref$clickableLeading === void 0 ? true : _ref$clickableLeading,
    _ref$promotedLabels = _ref.promotedLabels,
    promotedLabels = _ref$promotedLabels === void 0 ? [RecommendationLabel.EXACT_MATCH] : _ref$promotedLabels,
    _ref$useCompactRecomm = _ref.useCompactRecommendationsLayout,
    useCompactRecommendationsLayoutProp = _ref$useCompactRecomm === void 0 ? false : _ref$useCompactRecomm,
    _ref$isLeanView = _ref.isLeanView,
    isLeanView = _ref$isLeanView === void 0 ? false : _ref$isLeanView,
    _ref$hideAlternatives = _ref.hideAlternativesHeading,
    hideAlternativesHeading = _ref$hideAlternatives === void 0 ? false : _ref$hideAlternatives,
    alternativesHeadingGap = _ref.alternativesHeadingGap,
    _ref$showTrustBuilder = _ref.showTrustBuilders,
    showTrustBuilders = _ref$showTrustBuilder === void 0 ? true : _ref$showTrustBuilder,
    _ref$hideFreeWithSite = _ref.hideFreeWithSitePlanBadge,
    hideFreeWithSitePlanBadge = _ref$hideFreeWithSite === void 0 ? false : _ref$hideFreeWithSite,
    _ref$hideExactMatchHe = _ref.hideExactMatchHeadline,
    hideExactMatchHeadline = _ref$hideExactMatchHe === void 0 ? false : _ref$hideExactMatchHe,
    pricingOptimized = _ref.pricingOptimized,
    _ref$isBusinessEmail = _ref.isBusinessEmail,
    isBusinessEmail = _ref$isBusinessEmail === void 0 ? false : _ref$isBusinessEmail,
    _ref$isPricingLoading = _ref.isPricingLoading,
    isPricingLoading = _ref$isPricingLoading === void 0 ? false : _ref$isPricingLoading,
    _ref$suppressHarmonyC = _ref.suppressHarmonyCardStyling,
    suppressHarmonyCardStyling = _ref$suppressHarmonyC === void 0 ? false : _ref$suppressHarmonyC,
    desktopContentPadding = _ref.desktopContentPadding,
    _ref$bareListOnly = _ref.bareListOnly,
    bareListOnly = _ref$bareListOnly === void 0 ? false : _ref$bareListOnly,
    _ref$desktopContentGa = _ref.desktopContentGap,
    desktopContentGap = _ref$desktopContentGa === void 0 ? '10px' : _ref$desktopContentGa,
    _ref$insightsPaddingT = _ref.insightsPaddingTop,
    insightsPaddingTop = _ref$insightsPaddingT === void 0 ? 'SP2' : _ref$insightsPaddingT,
    _ref$compactPriceLabe = _ref.compactPriceLabel,
    compactPriceLabel = _ref$compactPriceLabe === void 0 ? false : _ref$compactPriceLabe,
    _ref$stackedMobileCar = _ref.stackedMobileCards,
    stackedMobileCards = _ref$stackedMobileCar === void 0 ? false : _ref$stackedMobileCar,
    layoutsOverride = _ref.Layouts,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  // Business email results reuse the optimized results layout (bordered
  // suggestions box, optimized hero + labels) plus the Google Workspace content.
  const useCompactRecommendationsLayout = useCompactRecommendationsLayoutProp || isBusinessEmail;
  const leanView = isLeanView || useCompactRecommendationsLayout;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useGetPurchasePermissions({}),
    purchasePermissions = _DomainsApiClient$hoo.data;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.useSuggestionActionResolver(),
    resolveActionForSuggestion = _DomainSearchSuiteMod.resolveActionForSuggestion;
  const isMobile = useIsMobile();
  const isHarmonyTheme = useIsHarmonyTheme();
  const _useMatchingLabels = useMatchingLabels(recommendations, isBusinessEmail && !showHeroCard ? false : leanView),
    matchLabels = _useMatchingLabels.labels,
    isLoadingLabels = _useMatchingLabels.isLoading;
  const _useResultsPageConfig = useResultsPageConfig(),
    isExactMatchHeadlineVisible = _useResultsPageConfig.showExactMatchHeadline;
  const _useState = useState(false),
    isMouseInList = _useState[0],
    setIsMouseInList = _useState[1];
  const useStackedMobileCards = stackedMobileCards && isMobile;
  const handleGetItClick = recommendation => {
    const position = recommendations == null ? void 0 : recommendations.findIndex(_ref2 => {
      let id = _ref2.id;
      return id === recommendation.id;
    });
    DomainSearchSuiteModule.internals.bi.onGetItClick == null || DomainSearchSuiteModule.internals.bi.onGetItClick({
      domain: recommendation.domain || '',
      type: recommendation.label,
      position
    });
  };
  const onClickGetIt = async recommendation => {
    handleGetItClick(recommendation);
    if (recommendation.domain) {
      await resolveActionForSuggestion(recommendation.domain, recommendation.premium);
    }
  };
  const onClickCard = onItemClick ?? (clickableRows ? onClickGetIt : undefined);
  const onClickLeadingCard = clickableLeadingCard ? onClickCard : undefined;
  const hasExactMatchTop = ((_recommendations$ = recommendations[0]) == null ? void 0 : _recommendations$.label) === RecommendationLabel.EXACT_MATCH;
  const topLabel = (_recommendations$2 = recommendations[0]) == null ? void 0 : _recommendations$2.label;
  const isPromotedHeroTop = !!topLabel && promotedLabels.includes(topLabel);
  const isLeadingCardPending = isLeadingCardLoading ?? isLoading;
  const heroRecommendation = showHeroCard && isPromotedHeroTop ? recommendations[0] : undefined;
  const isExactMatchHero = (heroRecommendation == null ? void 0 : heroRecommendation.label) === RecommendationLabel.EXACT_MATCH;
  const businessEmailFirstRec = isBusinessEmail && !showHeroCard && !isLeadingCardPending && recommendations.length > 0 ? recommendations[0] : undefined;
  const businessEmailRest = !!businessEmailFirstRec;
  const compactExactMatch = useCompactRecommendationsLayout && !showHeroCard && !bareListOnly && !businessEmailFirstRec && hasExactMatchTop && !isLeadingCardPending ? recommendations[0] : undefined;
  const listItems = heroRecommendation || compactExactMatch || businessEmailFirstRec ? recommendations.slice(1) : recommendations;
  const showMainCards = useCompactRecommendationsLayout && !bareListOnly && !businessEmailFirstRec && !heroRecommendation && !compactExactMatch && !isLoading && listItems.length >= 2;
  const mainCardCount = useStackedMobileCards ? 1 : 2;
  const mainCardItems = showMainCards ? listItems.slice(0, mainCardCount) : [];
  const mainCardLabels = ((_mainCardItems$ = mainCardItems[0]) == null ? void 0 : _mainCardItems$.label) === RecommendationLabel.GREAT_ALTERNATIVE ? [RecommendationLabel.GREAT_ALTERNATIVE, 'RECOMMENDED'] : [RecommendationLabel.BEST_MATCH, RecommendationLabel.GREAT_ALTERNATIVE];
  const listItemsToRender = showMainCards ? listItems.slice(mainCardCount) : listItems;
  const listPositionOffset = (heroRecommendation || compactExactMatch || businessEmailFirstRec ? 1 : 0) + (showMainCards ? mainCardItems.length : 0);
  const showHeroListStyling = showHeroCard && (isLoading || !!heroRecommendation);
  const showAlternativesHeading = !hideAlternativesHeading && !isBusinessEmail && (!leanView || useCompactRecommendationsLayout) && isExactMatchHero && !isLoading && listItems.length > 0 && !isMobile;
  const hasLeadingCard = !!heroRecommendation || !!compactExactMatch || showMainCards || !!businessEmailFirstRec;
  const showAnimatedBanner = showTrustBuilders && hasLeadingCard && !isBusinessEmail && useCompactRecommendationsLayout;
  const listAbutsLeadingCards = useCompactRecommendationsLayout && !showTrustBuilders && hasLeadingCard && !showAlternativesHeading;
  const layouts = {
    ...SearchRecommendationLayout,
    ...layoutsOverride,
    LabelContainer: businessEmailRest ? LazyRecommendationLabel({
      isLoading: isLoadingLabels,
      matchLabels
    }) : useCompactRecommendationsLayout ? createOptimizedLabelContainer() : leanView ? createLeanLabelContainer({
      listItems,
      heroRecommendation,
      hideFreeWithSitePlanBadge,
      recommendations
    }) : LazyRecommendationLabel({
      isLoading: isLoadingLabels,
      matchLabels
    }),
    ...(getItButtonOverride && {
      GetItButton: getItButtonOverride
    }),
    ...(showHeroListStyling && !useCompactRecommendationsLayout && {
      HoverBox: _ref3 => {
        let children = _ref3.children,
          _className = _ref3.className,
          rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);
        return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
          style: {
            cursor: 'pointer'
          }
        }), children);
      },
      Divider: () => /*#__PURE__*/React.createElement(Divider, null),
      GetItButton: _ref4 => {
        let children = _ref4.children,
          priority = _ref4.priority,
          rest = _objectWithoutPropertiesLoose(_ref4, _excluded3);
        return /*#__PURE__*/React.createElement(Button, _extends({
          size: "medium",
          skin: "dark"
        }, rest, {
          className: s.GetItButton,
          priority: isMouseInList ? priority : 'secondary'
        }), children);
      }
    }),
    ...(businessEmailRest && {
      Divider: () => /*#__PURE__*/React.createElement(Divider, null),
      HoverBox: _ref5 => {
        let children = _ref5.children,
          _className = _ref5.className,
          rest = _objectWithoutPropertiesLoose(_ref5, _excluded4);
        return /*#__PURE__*/React.createElement(Box, _extends({}, rest, {
          className: s.businessEmailRow
        }), children);
      },
      GetItButton: _ref6 => {
        let children = _ref6.children,
          _priority = _ref6.priority,
          _className = _ref6.className,
          rest = _objectWithoutPropertiesLoose(_ref6, _excluded5);
        return /*#__PURE__*/React.createElement(Button, _extends({
          size: "medium",
          skin: "dark",
          priority: "secondary"
        }, rest, {
          className: s.businessEmailGetIt
        }), children);
      }
    })
  };
  const recommendationList = /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.SearchRecommendationList, {
    dataHook: RecommendationsDataHooks.list,
    onHoverChange: onInsightHoverChange,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    onClickGetIt: onClickGetIt,
    onItemClick: onClickCard,
    isLeanView: businessEmailRest ? false : leanView,
    useCompactSuggestionRowStyle: businessEmailRest ? false : useCompactRecommendationsLayout,
    pricingOptimized: pricingOptimized,
    isPricingLoading: isPricingLoading,
    compactPriceLabel: compactPriceLabel,
    titleOverflowStrategy: rowTitleOverflowStrategy,
    Layouts: {
      ...layouts,
      ...(isHarmonyTheme && !suppressHarmonyCardStyling && {
        SearchRecommendationContainer: _ref7 => {
          let className = _ref7.className,
            rest = _objectWithoutPropertiesLoose(_ref7, _excluded6);
          return /*#__PURE__*/React.createElement(layouts.SearchRecommendationContainer, _extends({}, rest, {
            backgroundColor: "white",
            className: [s.suggestionRowCard, className].filter(Boolean).join(' ')
          }));
        },
        SearchRecommendationSkeletonContainer: _ref8 => {
          let className = _ref8.className,
            rest = _objectWithoutPropertiesLoose(_ref8, _excluded7);
          return /*#__PURE__*/React.createElement(layouts.SearchRecommendationSkeletonContainer, _extends({}, rest, {
            backgroundColor: "white",
            className: [s.suggestionRowCard, className].filter(Boolean).join(' ')
          }));
        }
      })
    },
    items: listItemsToRender,
    positionOffset: listPositionOffset,
    reportImpressions: true,
    isLoading: isLoading,
    useMobileLayout: isMobile,
    onAiInsightsClick: onAiInsightsClick,
    firstSuggestionPrimary: !useCompactRecommendationsLayout && !heroRecommendation,
    defaultNonHovered: useCompactRecommendationsLayout
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    dataHook: RecommendationsDataHooks.component,
    flex: 1,
    direction: "vertical",
    padding: isMobile ? 'SP1 SP4 0' : '0 48px',
    gap: showHeroListStyling && !useCompactRecommendationsLayout ? 'SP6' : undefined
  }, props), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    marginBottom: listAbutsLeadingCards ? '20px' : undefined
  }, isExactMatchHero && (heroRecommendation == null ? void 0 : heroRecommendation.domain) && !isMobile && isExactMatchHeadlineVisible && !hideExactMatchHeadline && /*#__PURE__*/React.createElement(ExactMatchHeadline, {
    domain: heroRecommendation.domain
  }), (showHeroCard || useCompactRecommendationsLayout && !bareListOnly) && isLeadingCardPending && !heroRecommendation && /*#__PURE__*/React.createElement(HeroCardSkeleton, {
    optimizedSkeletonLayout: useCompactRecommendationsLayout
  }), heroRecommendation && /*#__PURE__*/React.createElement(HeroCard, {
    recommendation: heroRecommendation,
    impressionReport: {
      position: 1,
      pageNumber: 1
    },
    onClickGetIt: onClickGetIt,
    onItemClick: onClickLeadingCard,
    onAiInsightsClick: onAiInsightsClick,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    useCompactHeroCardLayout: useCompactRecommendationsLayout,
    titleOverflowStrategy: titleOverflowStrategy,
    desktopContentPadding: desktopContentPadding,
    desktopContentGap: desktopContentGap,
    insightsPaddingTop: insightsPaddingTop,
    compactPriceLabel: compactPriceLabel,
    inlineMobileActions: leanView,
    stackedMobileLayout: useStackedMobileCards,
    businessEmailExample: isBusinessEmail,
    Label: layoutsOverride == null ? void 0 : layoutsOverride.Label,
    isPricingLoading: isPricingLoading
  }), compactExactMatch && /*#__PURE__*/React.createElement(HeroCard, {
    recommendation: compactExactMatch,
    impressionReport: {
      position: 1,
      pageNumber: 1
    },
    onClickGetIt: onClickGetIt,
    onItemClick: onClickLeadingCard,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    useCompactHeroCardLayout: true,
    compact: true,
    stackedMobileLayout: useStackedMobileCards,
    businessEmailExample: isBusinessEmail,
    Label: layoutsOverride == null ? void 0 : layoutsOverride.Label,
    dataHook: "exact-match-card",
    isPricingLoading: isPricingLoading,
    compactPriceLabel: compactPriceLabel,
    titleOverflowStrategy: titleOverflowStrategy
  }), showMainCards && /*#__PURE__*/React.createElement(Box, {
    direction: isMobile ? 'vertical' : 'horizontal',
    gap: "16px",
    marginTop: isMobile ? undefined : '16px'
  }, mainCardItems.map((rec, index) => /*#__PURE__*/React.createElement(HeroCard, {
    key: rec.id ?? rec.domain,
    recommendation: rec,
    impressionReport: {
      position: index + 1,
      pageNumber: 1
    },
    onClickGetIt: onClickGetIt,
    onItemClick: onClickLeadingCard,
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    useCompactHeroCardLayout: true,
    compact: true,
    stackedMobileLayout: useStackedMobileCards,
    badgeLabel: mainCardLabels[index],
    ctaPriority: index === 0 ? 'primary' : 'secondary',
    businessEmailExample: isBusinessEmail,
    Label: layoutsOverride == null ? void 0 : layoutsOverride.Label,
    dataHook: `main-card-${index}`,
    isPricingLoading: isPricingLoading,
    compactPriceLabel: compactPriceLabel,
    titleOverflowStrategy: titleOverflowStrategy
  }))), businessEmailFirstRec && /*#__PURE__*/React.createElement(Box, {
    borderRadius: isHarmonyTheme ? undefined : '12px',
    border: isHarmonyTheme ? undefined : '1px solid var(--wds-color-border-disabled, #e5e5e5)',
    className: isHarmonyTheme ? undefined : s.suggestionsContainer
  }, /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.SearchRecommendationList, {
    disabled: !(purchasePermissions != null && purchasePermissions.hasPermission),
    onClickGetIt: onClickGetIt,
    onItemClick: onClickCard,
    items: [businessEmailFirstRec],
    reportImpressions: true,
    useMobileLayout: isMobile,
    firstSuggestionPrimary: true,
    defaultNonHovered: true,
    isPricingLoading: isPricingLoading,
    compactPriceLabel: compactPriceLabel,
    Layouts: {
      ...SearchRecommendationLayout,
      ...layoutsOverride,
      ...(getItButtonOverride && {
        GetItButton: getItButtonOverride
      }),
      HoverBox: _ref9 => {
        let children = _ref9.children,
          _className = _ref9.className,
          rest = _objectWithoutPropertiesLoose(_ref9, _excluded8);
        return /*#__PURE__*/React.createElement(Box, rest, children);
      },
      TitleDisplay: titleProps => /*#__PURE__*/React.createElement(Box, {
        direction: "vertical",
        gap: "2px"
      }, /*#__PURE__*/React.createElement(SearchRecommendationLayout.TitleDisplay, titleProps), /*#__PURE__*/React.createElement(Box, {
        paddingLeft: businessEmailFirstRec.label === RecommendationLabel.EXACT_MATCH ? 'SP4' : undefined
      }, /*#__PURE__*/React.createElement(HeroBusinessEmailExample, {
        domain: businessEmailFirstRec.domain ?? '',
        size: "small"
      })))
    }
  })), hasLeadingCard && isBusinessEmail && /*#__PURE__*/React.createElement(GoogleWorkspaceBanner, null), showAnimatedBanner && /*#__PURE__*/React.createElement(AnimatedBanner, null)), /*#__PURE__*/React.createElement("div", {
    onMouseEnter: showHeroListStyling ? () => setIsMouseInList(true) : undefined,
    onMouseLeave: showHeroListStyling ? () => setIsMouseInList(false) : undefined
  }, showAlternativesHeading && /*#__PURE__*/React.createElement(Box, {
    marginTop: "18px",
    marginBottom: alternativesHeadingGap ?? (useCompactRecommendationsLayout ? '32px' : undefined)
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "medium",
    as: "h2"
  }, t('domain_search_gate.results.alternative_suggestion_list.title'))), useCompactRecommendationsLayout ? /*#__PURE__*/React.createElement(Box, {
    borderRadius: bareListOnly || isHarmonyTheme && !suppressHarmonyCardStyling ? undefined : '12px',
    border: bareListOnly || isHarmonyTheme && !suppressHarmonyCardStyling ? undefined : '1px solid var(--wds-color-border-disabled, #e5e5e5)',
    className: bareListOnly || isHarmonyTheme && !suppressHarmonyCardStyling ? undefined : s.suggestionsContainer
  }, recommendationList) : recommendationList), hasMore && !bareListOnly && /*#__PURE__*/React.createElement(Box, {
    flex: 1,
    align: "center",
    padding: "SP8 SP4 SP10 SP4"
  }, /*#__PURE__*/React.createElement(TextButton, {
    skin: "dark",
    onClick: () => fetchNextPage(),
    suffixIcon: isFetchingNextPage ? /*#__PURE__*/React.createElement(Box, {
      marginLeft: "3px",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "tiny"
    })) : /*#__PURE__*/React.createElement(ChevronDown, null)
  }, t('domain_search_gate.results.show_more'))));
};
//# sourceMappingURL=Recommendations.js.map